<template>
    <el-drawer title="添加动态加价" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="160px" style="height: 90vh; overflow-y: auto">
                    <el-form-item label="金额（元）：">
                        <el-input
                            v-model="submit_data.amount"
                            :placeholder="submit_rules.amount.placeholder"
                            style="width: 150px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="城市收取金额（元）：">
                        <el-input
                            v-model="submit_data.city_amount"
                            :placeholder="submit_rules.city_amount.placeholder"
                            style="width: 150px"
                        >
                        </el-input
                        >
                    </el-form-item>
                </el-form>
                <!-- 对话框底部按钮 -->
                <div style="display:flex;justify-content:center">
                    <submitBtn
                        @onSubmitDig="onSubmitDig"
                        :data="submit_data"
                        :rules="submit_rules"
                        :url="submit_url"
                        :JSON_Boolean="false"
                    ></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-drawer>
</template>
<script>
var _this;
export default {
    props: {
        isShow: Boolean
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
        }
    },
    data() {
        return {
            show: false,
            submit_url: '/dynamicmarkup/addDynamicMarkup',
            submit_data: {
                amount: '',
                city_amount: ''
            },
            submit_rules: {
                amount: {
                    placeholder: '金额',
                    rules: {
                        required: true,
                        message: '金额为大于0的整数',
                        regulation: 'int',
                        rulesData: 1
                    }
                },
                city_amount: {
                    placeholder: '城市收取金额',
                    rules: {
                        required: true,
                        message: '城市收取金额为大于等于0的整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 关闭方法
        closeDialog() {
            _this.show = false;
            for (const key in _this.submit_data) {
                _this.submit_data[key] = '';
            }
        },
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        }
    }
};
</script>
<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}
.item-wrap {
    margin-bottom: 10px;
}
</style>